// extracted by mini-css-extract-plugin
export var ThumbnailWrapper = "thumbnail-module--ThumbnailWrapper--u4rc3";
export var Thumbnail = "thumbnail-module--Thumbnail--fSjyj";
export var ThumbnailDescription = "thumbnail-module--ThumbnailDescription--1fujG";